import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import es from "./locales/es";
import en from "./locales/en";
import { isBinapsisBrand } from "../utils/utils";

export const LOCALE_STORAGE_KEY = "binapsis-locale";

function resolveInitialLanguage() {
  if (!isBinapsisBrand()) {
    return "es";
  }

  const saved = localStorage.getItem(LOCALE_STORAGE_KEY);
  if (saved === "es" || saved === "en") {
    return saved;
  }

  const browserLang = navigator.language?.toLowerCase() || "";
  return browserLang.startsWith("en") ? "en" : "es";
}

const initialLanguage = resolveInitialLanguage();
document.documentElement.lang = initialLanguage;

i18n.use(initReactI18next).init({
  resources: {
    es: { translation: es },
    en: { translation: en },
  },
  lng: initialLanguage,
  fallbackLng: "es",
  interpolation: {
    escapeValue: false,
  },
});

export function changeLanguage(lng) {
  if (!isBinapsisBrand()) return;
  if (lng !== "es" && lng !== "en") return;
  localStorage.setItem(LOCALE_STORAGE_KEY, lng);
  document.documentElement.lang = lng;
  return i18n.changeLanguage(lng);
}

export default i18n;
